import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, TextField, Typography } from '@mui/material';
import { DEFAULT_CURRENCY, formatMoney, getCurrency } from '../../../../utils/currency';

const StepCashPayment = ({ total, cashReceived, onCashReceivedChange, parsedCashReceived, currency, ticketCurrency = currency, ticketTotal = total, ticketRate }) => {
  const payingInOtherCurrency = currency !== ticketCurrency;
  const pendingAmount = Math.max(total - parsedCashReceived, 0);
  const changeAmount = Math.max(parsedCashReceived - total, 0);
  const hasEnteredAmount = cashReceived.trim() !== '';

  return (
    <>
      <Typography variant="subtitle1" gutterBottom>
        Pago en efectivo
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Ingresá con cuánto pagó el cliente para calcular el cambio.
      </Typography>

      <Box sx={{ display: 'grid', gap: 2 }}>
        {payingInOtherCurrency && (
          <Typography variant="caption" color="text.secondary">
            {`${formatMoney(ticketTotal, ticketCurrency)} × ${formatMoney(ticketRate, DEFAULT_CURRENCY, { decimals: 3 })} = ${formatMoney(total, currency)}`}
          </Typography>
        )}
        <TextField
          label={`Pagó con (${getCurrency(currency).label})`}
          value={cashReceived}
          onChange={(e) => onCashReceivedChange(e.target.value)}
          fullWidth
          inputProps={{ inputMode: 'decimal' }}
          placeholder="0.00"
        />

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: hasEnteredAmount ? '1fr 1.15fr' : '1fr' },
            gap: 1.5
          }}
        >
          <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#f7f7f7' }}>
            <Typography variant="body2" color="text.secondary">
              Total de la venta
            </Typography>
            <Typography variant="h5">{formatMoney(total, currency)}</Typography>
          </Box>

          {hasEnteredAmount && parsedCashReceived < total && (
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: '#fff3e0',
                border: '1px solid #ffcc80',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <WarningAmberIcon sx={{ color: '#ed6c02', fontSize: 30, flexShrink: 0 }} />
              <Box>
                <Typography variant="body2" sx={{ color: '#8a4b00', fontWeight: 600 }}>
                  Falta pagar
                </Typography>
                <Typography variant="h4" sx={{ color: '#663c00', fontWeight: 700 }}>
                  {formatMoney(pendingAmount, currency)}
                </Typography>
              </Box>
            </Box>
          )}

          {hasEnteredAmount && parsedCashReceived >= total && (
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: '#e6f6ec',
                border: '1px solid #9ee2b3',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <CheckCircleOutlineIcon sx={{ color: '#2e7d32', fontSize: 30, flexShrink: 0 }} />
              <Box>
                <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600 }}>
                  A devolver
                </Typography>
                <Typography variant="h4" sx={{ color: '#1b5e20', fontWeight: 700 }}>
                  {formatMoney(changeAmount, currency)}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default StepCashPayment;
